var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7787 0H3.22131C1.44507 0 0 1.82658 0 4.07127V19.9279C0 22.1734 1.44507 24 3.22131 24H22.7787C24.5549 24 26 22.1734 26 19.9279V4.07127C25.9997 1.82658 24.5546 0 22.7787 0ZM25.0615 19.9283C25.0615 21.5198 24.0374 22.8148 22.7784 22.8148H3.221C1.96231 22.8148 0.937841 21.5202 0.937841 19.9283V4.07166C0.937841 2.48062 1.96199 1.18597 3.221 1.18597H22.7784C24.0371 1.18597 25.0615 2.48062 25.0615 4.07166V19.9283Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3077 12.9351H4.47229C4.21336 12.9351 4.00322 13.2006 4.00322 13.5278C4.00322 13.8555 4.21336 14.1206 4.47229 14.1206H11.3077C11.5666 14.1206 11.7768 13.8555 11.7768 13.5278C11.7768 13.2006 11.5666 12.9351 11.3077 12.9351Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3077 9.45496H4.47229C4.21336 9.45496 4.00322 9.72013 4.00322 10.0477C4.00322 10.375 4.21336 10.6405 4.47229 10.6405H11.3077C11.5666 10.6405 11.7768 10.375 11.7768 10.0477C11.7768 9.72052 11.5666 9.45496 11.3077 9.45496Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9056 16.0769C19.6467 16.0769 19.4365 16.3421 19.4365 16.6697V19.5502C19.4365 19.8775 19.6467 20.143 19.9056 20.143C20.1645 20.143 20.3747 19.8775 20.3747 19.5502V16.6697C20.3747 16.3425 20.1645 16.0769 19.9056 16.0769Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9056 10.3199C19.6467 10.3199 19.4365 10.5855 19.4365 10.9127V13.7921C19.4365 14.1197 19.6467 14.3849 19.9056 14.3849C20.1645 14.3849 20.3747 14.1197 20.3747 13.7921V10.9127C20.3747 10.5855 20.1645 10.3199 19.9056 10.3199Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9056 4.56128C19.6467 4.56128 19.4365 4.82685 19.4365 5.15407V8.03462C19.4365 8.36223 19.6467 8.62741 19.9056 8.62741C20.1645 8.62741 20.3747 8.36223 20.3747 8.03462V5.15407C20.3747 4.82685 20.1645 4.56128 19.9056 4.56128Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/TicketIcon.c0d3188da6e1f26d4843f41235a05271.svg";
export { ForwardRef as ReactComponent };